// let slideIndex = 1;
// let totalSlides = 4; // PCは4枚
// let slideInterval;

// function showSlides(n) {
//     let i;
//     let slides = document.getElementsByClassName("mySlides2");  // クラス名を修正
//     let pcDots = document.querySelectorAll(".pc-pagination2 .dot2");  // クラス名を修正
//     let mobileDots = document.querySelectorAll(".mobile-pagination2 .dot2");  // クラス名を修正

//     if (n > totalSlides) { slideIndex = 1; }
//     if (n < 1) { slideIndex = totalSlides; }
//     for (i = 0; i < slides.length; i++) {
//         slides[i].style.display = "none";
//     }
//     slides[slideIndex - 1].style.display = "block";

//     pcDots.forEach(dot => dot.className = dot.className.replace(" active", ""));
//     mobileDots.forEach(dot => dot.className = dot.className.replace(" active", ""));

//     if (pcDots[slideIndex - 1]) {
//         pcDots[slideIndex - 1].className += " active";
//     }
//     if (mobileDots[slideIndex - 1]) {
//         mobileDots[slideIndex - 1].className += " active";
//     }
// }

// function plusSlides(n) {
//     clearInterval(slideInterval);
//     showSlides(slideIndex += n);
//     slideInterval = setInterval(() => plusSlides(1), 3000);  // 3秒ごとにスライド
// }

// function currentSlide(n) {
//     clearInterval(slideInterval);
//     showSlides(slideIndex = n);
//     slideInterval = setInterval(() => plusSlides(1), 3000);
// }

// function detectDevice() {
//     if (window.innerWidth < 1024) {
//         totalSlides = 5;  // モバイルは5枚
//         document.querySelectorAll('.mobile-only-slide2').forEach(slide => slide.style.display = "block");
//         document.querySelectorAll('.pc-pagination2').forEach(pagination => pagination.style.display = "none");
//         document.querySelectorAll('.mobile-pagination2').forEach(pagination => pagination.style.display = "block");
//     } else {
//         totalSlides = 4;  // PCは4枚
//         document.querySelectorAll('.mobile-only-slide2').forEach(slide => slide.style.display = "none");
//         document.querySelectorAll('.pc-pagination2').forEach(pagination => pagination.style.display = "block");
//         document.querySelectorAll('.mobile-pagination2').forEach(pagination => pagination.style.display = "none");
//     }
// }

// document.addEventListener("DOMContentLoaded", function() {
//     detectDevice();
//     showSlides(slideIndex);
//     slideInterval = setInterval(() => plusSlides(1), 3000);
// });

// window.onresize = detectDevice;







// let slideIndex = 1;
// let totalSlides = 4; // デフォルトはPCの4枚
// let slideInterval;

// function showSlides(n) {
//     let slides = document.getElementsByClassName("mySlides2"); // クラス名を修正
//     let pcDots = document.querySelectorAll(".pc-pagination2 .dot2"); // クラス名を修正
//     let mobileDots = document.querySelectorAll(".mobile-pagination2 .dot2"); // クラス名を修正

//     if (n > totalSlides) slideIndex = 1;
//     if (n < 1) slideIndex = totalSlides;
//     for (let i = 0; i < slides.length; i++) {
//         slides[i].style.display = "none"; // Hide all slides
//     }
//     slides[slideIndex - 1].style.display = "block"; // Show the current slide

//     // Reset all dots to inactive
//     [...pcDots, ...mobileDots].forEach(dot => {
//         dot.className = dot.className.replace(" active", "");
//     });

//     // Activate the current dot
//     if (pcDots[slideIndex - 1]) pcDots[slideIndex - 1].className += " active";
//     if (mobileDots[slideIndex - 1]) mobileDots[slideIndex - 1].className += " active";
// }

// function plusSlides(n) {
//     clearInterval(slideInterval); // Stop the auto-play
//     showSlides(slideIndex += n);
//   slideInterval = setInterval(() => plusSlides(1), 3000);  // 自動再生を再開
// }

// function currentSlide(n) {
//     clearInterval(slideInterval); // Stop the auto-play
//     showSlides(slideIndex = n);
//   slideInterval = setInterval(() => plusSlides(1), 3000);  // 自動再生を再開
// }

// function detectDevice() {
//     totalSlides = window.innerWidth < 1024 ? 5 : 4; // 5 for mobile, 4 for PC
//     document.querySelectorAll('.mobile-only-slide2').forEach(slide => {
//         slide.style.display = window.innerWidth < 1024 ? "block" : "none";
//     });
//     document.querySelectorAll('.pc-pagination2').forEach(pagination => {
//         pagination.style.display = window.innerWidth >= 1024 ? "block" : "none";
//     });
//     document.querySelectorAll('.mobile-pagination2').forEach(pagination => {
//         pagination.style.display = window.innerWidth < 1024 ? "block" : "none";
//     });
// }

// document.addEventListener("DOMContentLoaded", function() {
//     detectDevice();
//     showSlides(slideIndex);
//     slideInterval = setInterval(() => plusSlides(1), 3000); // Start auto-play

//     // Add event listeners for navigation and pagination to stop auto-play
//     document.querySelector('.prev2').addEventListener('click', () => plusSlides(-1));
//     document.querySelector('.next2').addEventListener('click', () => plusSlides(1));
//     document.querySelectorAll('.pc-pagination2 .dot2').forEach((dot, index) => {
//         dot.addEventListener('click', () => currentSlide(index + 1));
//     });
//     document.querySelectorAll('.mobile-pagination2 .dot2').forEach((dot, index) => {
//         dot.addEventListener('click', () => currentSlide(index + 1));
//     });
// });

// window.onresize = detectDevice; // Adjust settings on window resize




// let slideIndex = 1;
// let totalSlides = 4; // デフォルトはPCの4枚
// let slideInterval;

// function showSlides(n) {
//     let slides = document.getElementsByClassName("mySlides2");
//     let pcDots = document.querySelectorAll(".pc-pagination2 .dot2");
//     let mobileDots = document.querySelectorAll(".mobile-pagination2 .dot2");

//     if (n > totalSlides) {
//         slideIndex = 1;  // 最初のスライドに戻る
//     } else if (n < 1) {
//         slideIndex = totalSlides;  // 最後のスライドに戻る
//     } else {
//         slideIndex = n;
//     }

//     for (let i = 0; i < slides.length; i++) {
//         slides[i].style.display = "none";  // 全スライドを非表示
//     }
//     slides[slideIndex - 1].style.display = "block";  // 現在のスライドを表示

//     pcDots.forEach(dot => dot.className = dot.className.replace(" active", ""));
//     mobileDots.forEach(dot => dot.className = dot.className.replace(" active", ""));
//     if (pcDots[slideIndex - 1]) pcDots[slideIndex - 1].className += " active";
//     if (mobileDots[slideIndex - 1]) mobileDots[slideIndex - 1].className += " active";
// }



// }
// function plusSlides(n) {
//     clearInterval(slideInterval);
//     showSlides(slideIndex += n);
//     slideInterval = setInterval(() => plusSlides(1), 3000); 
// }

// function currentSlide(n) {
//     clearInterval(slideInterval);
//     showSlides(slideIndex = n);
//     slideInterval = setInterval(() => plusSlides(1), 3000);
// }

// function detectDevice() {
//     if (window.innerWidth < 1024) {
//         totalSlides = 5; // スマホの場合は5枚
//         document.querySelectorAll('.mobile-only-slide2').forEach(slide => slide.style.display = "block");
//         document.querySelectorAll('.pc-pagination2').forEach(pagination => pagination.style.display = "none");
//         document.querySelectorAll('.mobile-pagination2').forEach(pagination => pagination.style.display = "block");
//     } else {
//         totalSlides = 4; // PCの場合は4枚
//         document.querySelectorAll('.mobile-only-slide2').forEach(slide => slide.style.display = "none");
//         document.querySelectorAll('.pc-pagination2').forEach(pagination => pagination.style.display = "block");
//         document.querySelectorAll('.mobile-pagination2').forEach(pagination => pagination.style.display = "none");
//     }
// }

// document.addEventListener("DOMContentLoaded", function() {
//     detectDevice();
//     showSlides(slideIndex);
//     slideInterval = setInterval(() => plusSlides(1), 3000);

//    // 左右のナビゲーションボタンにイベントリスナーを追加し、クリックで自動再生を停止
//     document.querySelector('.prev2').addEventListener('click', () => plusSlides(-1));
//     document.querySelector('.next2').addEventListener('click', () => plusSlides(1));

//     // ページネーションのドットにイベントリスナーを追加し、クリックで自動再生を停止
//     document.querySelectorAll('.pc-pagination2 .dot2').forEach((dot, index) => {
//         dot.addEventListener('click', () => currentSlide(index + 1));
//     });
//     document.querySelectorAll('.mobile-pagination2 .dot2').forEach((dot, index) => {
//         dot.addEventListener('click', () => currentSlide(index + 1));
//     });
// });

// window.onresize = function() {
//     detectDevice();
//     showSlides(slideIndex);
// }










let slideIndex = 1;
let totalSlides = 5; // デフォルトはPCの5枚
let slideInterval;

function showSlides(n) {
    let slides = document.getElementsByClassName("mySlides2");
    let pcDots = document.querySelectorAll(".pc-pagination2 .dot2");
    let mobileDots = document.querySelectorAll(".mobile-pagination2 .dot2");

    if (n > totalSlides) {
        slideIndex = 1;  // 最初のスライドに戻る
    } else if (n < 1) {
        slideIndex = totalSlides;  // 最後のスライドに戻る
    } else {
        slideIndex = n;
    }

    for (let i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";  // 全スライドを非表示
    }
    slides[slideIndex - 1].style.display = "block";  // 現在のスライドを表示

    pcDots.forEach(dot => dot.className = dot.className.replace(" active", ""));
    mobileDots.forEach(dot => dot.className = dot.className.replace(" active", ""));
    if (pcDots[slideIndex - 1]) pcDots[slideIndex - 1].className += " active";
    if (mobileDots[slideIndex - 1]) mobileDots[slideIndex - 1].className += " active";
}

function plusSlides(n) {
    showSlides(slideIndex += n);
}

function currentSlide(n) {
    showSlides(slideIndex = n);
}

function detectDevice() {
    if (window.innerWidth < 1024) {
        totalSlides = 8; // スマホの場合は8枚
        document.querySelectorAll('.mobile-only-slide2').forEach(slide => slide.style.display = "block");
        document.querySelectorAll('.pc-pagination2').forEach(pagination => pagination.style.display = "none");
        document.querySelectorAll('.mobile-pagination2').forEach(pagination => pagination.style.display = "block");
    } else {
        totalSlides = 5; // PCの場合は5枚
        document.querySelectorAll('.mobile-only-slide2').forEach(slide => slide.style.display = "none");
        document.querySelectorAll('.pc-pagination2').forEach(pagination => pagination.style.display = "block");
        document.querySelectorAll('.mobile-pagination2').forEach(pagination => pagination.style.display = "none");
    }
}

function startAutoSlide() {
    slideInterval = setInterval(() => plusSlides(1), 3000);
}

function stopAutoSlide() {
    clearInterval(slideInterval);
}

document.addEventListener("DOMContentLoaded", function() {
    detectDevice();
    showSlides(slideIndex);
    startAutoSlide();

    // 左右のナビゲーションボタンにイベントリスナーを追加し、クリックで自動再生を停止
    document.querySelector('.prev2').addEventListener('click', () => {
        stopAutoSlide();
        plusSlides(-1);
    });
    document.querySelector('.next2').addEventListener('click', () => {
        stopAutoSlide();
        plusSlides(1);
    });

    // ページネーションのドットにイベントリスナーを追加し、クリックで自動再生を停止
    document.querySelectorAll('.pc-pagination2 .dot2').forEach((dot, index) => {
        dot.addEventListener('click', () => {
            stopAutoSlide();
            currentSlide(index + 1);
        });
    });
    document.querySelectorAll('.mobile-pagination2 .dot2').forEach((dot, index) => {
        dot.addEventListener('click', () => {
            stopAutoSlide();
            currentSlide(index + 1);
        });
    });
});

window.onresize = function() {
    detectDevice();
    showSlides(slideIndex);
}

